var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-select-price-dropdown-content" }, [
    _c("div", { staticClass: "inner" }, [
      _c(
        "div",
        { staticClass: "input-wrap input-wrap_first" },
        [
          _c("label", { staticClass: "label" }, [_vm._v("от")]),
          _c("ui-input", {
            attrs: { placeholder: "", numbers: "" },
            on: { blur: _vm.updateFrom },
            model: {
              value: _vm.localFrom,
              callback: function($$v) {
                _vm.localFrom = $$v
              },
              expression: "localFrom"
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "input-wrap" },
        [
          _c("label", { staticClass: "label" }, [_vm._v("до")]),
          _c("ui-input", {
            attrs: { placeholder: "", numbers: "" },
            on: { blur: _vm.updateTo },
            model: {
              value: _vm.localTo,
              callback: function($$v) {
                _vm.localTo = $$v
              },
              expression: "localTo"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }